import { routerMiddleware, connectRouter } from 'connected-react-router';
import { applyMiddleware, createStore, compose } from 'redux';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { combinedAppReducers } from './reducers';
import rootSaga from './sagas';
import { isDevEnvironment, isProdEnvironment } from '../utils/config';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const middlewares = [routerMiddleware(history), sagaMiddleware];

if (isDevEnvironment && window.enableLogger)
  // eslint-disable-next-line import/no-extraneous-dependencies
  middlewares.push(require('redux-logger').logger);

const composeEnhancers =
  (!isProdEnvironment && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(
  connectRouter(history)(combinedAppReducers),
  composeEnhancers(applyMiddleware(...middlewares))
);

sagaMiddleware.run(rootSaga);

export { store, history };
